class ProductStickyNav extends HTMLElement {
  constructor() {
    super();
    const productInfo = document.querySelector("product-info");
    this.scrollThreshold = productInfo
      ? productInfo.getBoundingClientRect().height
      : 400;
    this.button = this.querySelector(".product-sticky-nav-cta");
    this.faqLink = this.querySelector("[data-faq]");
    this.detailsLink = this.querySelector("[data-detail]");
    this.reviewsLink = this.querySelector("[data-review]");
    this.navLinks = [this.detailsLink, this.faqLink, this.reviewsLink].filter(
      Boolean
    );
  }

  getFaqTarget() {
    const sel = this.dataset.faqTarget || ".section-bundle-faq";
    try {
      return document.querySelector(sel);
    } catch {
      return null;
    }
  }

  getReviewTarget() {
    const preferredSelectors = [
      "#judgeme_product_reviews",
      ".bizfurniz-judgeme-reviews-section",
      this.dataset.reviewTarget,
      ".jdgm-carousel-wrapper",
    ].filter(Boolean);

    for (const sel of preferredSelectors) {
      try {
        const el = document.querySelector(sel);
        if (el) return el;
      } catch {}
    }

    try {
      return null;
    } catch {
      return null;
    }
  }

  getDetailsTarget() {
    const productInfo = document.querySelector("product-info");
    if (productInfo) return productInfo;
    return document.querySelector("#MainContent > *:nth-child(2)");
  }

  scrollToTarget(el) {
    if (!el) return;
    const navOffset = this.offsetHeight || 0;
    const y =
      el.getBoundingClientRect().top +
      (window.scrollY || document.documentElement.scrollTop) -
      navOffset -
      10;
    window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
  }

  getSpyScrollY() {
    const y = window.scrollY || document.documentElement.scrollTop;
    const navOffset =
      this.classList.contains("active") ? this.offsetHeight : 0;
    return y + navOffset + 12;
  }

  setActiveLink(active) {
    for (const link of this.navLinks) {
      link.classList.toggle("is-active", link === active);
    }
  }

  updateActiveFromScroll() {
    const faqEl = this.getFaqTarget();
    const reviewEl = this.getReviewTarget();
    const line = this.getSpyScrollY();

    const topOf = (el) => {
      if (!el) return Infinity;
      const r = el.getBoundingClientRect();
      return r.top + (window.scrollY || document.documentElement.scrollTop);
    };

    const faqTop = topOf(faqEl);
    const reviewTop = topOf(reviewEl);

    if (!faqEl && reviewEl) {
      this.setActiveLink(
        line < reviewTop ? this.detailsLink : this.reviewsLink
      );
      return;
    }

    if (faqEl && line < faqTop) {
      this.setActiveLink(this.detailsLink);
      return;
    }
    if (faqEl && (!reviewEl || line < reviewTop)) {
      this.setActiveLink(this.faqLink);
      return;
    }
    if (reviewEl) {
      this.setActiveLink(this.reviewsLink);
      return;
    }
    if (faqEl) {
      this.setActiveLink(this.faqLink);
      return;
    }
    this.setActiveLink(this.detailsLink);
  }

  connectedCallback() {
    const onScroll = () => {
      const currentScroll =
        window.scrollY || document.documentElement.scrollTop;

      if (currentScroll > this.scrollThreshold) {
        this.classList.add("active");
        document
          .querySelectorAll(".shopify-section-group-header-group")
          .forEach((el) => {
            el.classList.add("hidden");
          });
      } else {
        document
          .querySelectorAll(".shopify-section-group-header-group")
          .forEach((el) => {
            el.classList.remove("hidden");
          });
        this.classList.remove("active");
      }

      this.updateActiveFromScroll();
    };

    const throttled = this.throttle(onScroll, 80);
    window.addEventListener("scroll", throttled, { passive: true });
    window.addEventListener("resize", throttled);
    this._scrollHandler = throttled;

    onScroll();

    if (this.faqLink) {
      this.faqLink.addEventListener("click", (e) => {
        e.preventDefault();
        const el = this.getFaqTarget();
        this.scrollToTarget(el);
      });
    }
    if (this.reviewsLink) {
      this.reviewsLink.addEventListener("click", (e) => {
        e.preventDefault();
        const el = this.getReviewTarget();
        this.scrollToTarget(el);
      });
    }
    if (this.detailsLink) {
      this.detailsLink.addEventListener("click", (e) => {
        e.preventDefault();
        const el = this.getDetailsTarget();
        this.scrollToTarget(el);
      });
    }
  }

  disconnectedCallback() {
    if (this._scrollHandler) {
      window.removeEventListener("scroll", this._scrollHandler);
      window.removeEventListener("resize", this._scrollHandler);
    }
  }

  throttle(func, limit = 100) {
    let lastFunc;
    let lastRan;
    return function () {
      const context = this;
      const args = arguments;
      if (!lastRan) {
        func.apply(context, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(function () {
          if (Date.now() - lastRan >= limit) {
            func.apply(context, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    };
  }
}
if (!customElements.get("product-sticky-nav")) {
  customElements.define("product-sticky-nav", ProductStickyNav);
}

(function () {
  function styleJudgeMeTitle() {
    document
      .querySelectorAll(
        "#judgeme_product_reviews .jdgm-rev-widg__title, .bizfurniz-judgeme-reviews .jdgm-rev-widg__title"
      )
      .forEach((title) => {
        title.style.setProperty("color", "#181818", "important");
        title.style.setProperty("font-family", "inherit", "important");
        title.style.setProperty(
          "font-size",
          window.matchMedia("(max-width: 768px)").matches ? "22px" : "32px",
          "important"
        );
        title.style.setProperty("font-weight", "400", "important");
        title.style.setProperty("line-height", "1.2", "important");
        title.style.setProperty("letter-spacing", "normal", "important");
        title.style.setProperty("text-align", "center", "important");
        title.style.setProperty("visibility", "visible", "important");
        title.style.setProperty("opacity", "1", "important");
        title.style.setProperty("display", "block", "important");
        title.style.setProperty("width", "100%", "important");
        title.style.setProperty("margin", "0 0 24px", "important");
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", styleJudgeMeTitle);
  } else {
    styleJudgeMeTitle();
  }
  window.addEventListener("load", styleJudgeMeTitle);
  window.addEventListener("resize", styleJudgeMeTitle);
  setTimeout(styleJudgeMeTitle, 500);
  setTimeout(styleJudgeMeTitle, 1500);
  setTimeout(styleJudgeMeTitle, 3000);

  new MutationObserver(styleJudgeMeTitle).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
